<div class="ai-assistant-container" (mouseenter)="stopReset()" (mousemove)="move($event)" (mouseleave)="leave($event)">
  <div class="gradient-border-mask" #gradientBorderMask [style.background]="gradient()"></div>
  <div class="ai-assistant-content">
    <div class="info-container">
      @if (avatarSrc()) {
        <glxy-avatar class="assistant-avatar" [src]="avatarSrc()" [useGrayScale]="isDisabled()"></glxy-avatar>
      } @else {
        <glxy-avatar class="assistant-avatar" [svgIcon]="defaultAvatarIcon" [useGrayScale]="isDisabled()"></glxy-avatar>
      }
      <div class="text-container">
        <p class="title">{{ aiAssistant().assistant.name }}</p>
        @if (aiAssistant().subtitleKey) {
          <p class="subtitle">{{ aiAssistant().subtitleKey | translate }}</p>
        }
      </div>
    </div>
    @if (aiAssistant().autonomyRating) {
      <ai-rating-badge
        [aiAssistant]="aiAssistant()"
        [label]="'AI_ASSISTANT.AUTONOMY_LABEL' | translate"
        [value]="aiAssistant().autonomyRating"
        [max]="4"
      ></ai-rating-badge>
    }
    <p class="description">
      {{ aiAssistant().descriptionKey | translate }}
    </p>
    @let aiConnections = uniqueConnections();
    @if (aiConnections && aiConnections.length > 0) {
      <div class="connections-container">
        @for (aiConnection of aiConnections; track aiConnection) {
          <img
            class="availability-icons"
            [class.greyscale]="aiConnection.isGreyscale"
            alt="{{ aiConnection.connection.connectionTypeName }}"
            [src]="aiConnection.iconUrl"
            [glxyTooltip]="aiConnection.connection.connectionTypeName + ' ' + (aiConnection.tooltip | translate)"
          />
        }
      </div>
    }
    <div class="actions">
      <!-- TODO: MEGA-2512 clean-up userCanChatWithEmployee -->
      @if (shouldShowChatButton()) {
        <button mat-flat-button color="primary" (click)="onChatButtonClick()">
          {{ 'AI_ASSISTANT.WORKFORCE.CHAT_BUTTON' | translate }}
        </button>
      }
      @if (shouldShowVoiceChatButton()) {
        @if (webrtcCallState() === 'idle' || webrtcCallState() === 'disconnected' || webrtcCallState() === 'error') {
          <button mat-flat-button color="primary" (click)="openVoiceChat()">
            <mat-icon>call</mat-icon>
            {{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.CALL' | translate }}
          </button>
        } @else if (webrtcCallState() === 'connecting') {
          <button mat-flat-button color="primary" disabled>
            {{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.CONNECTING' | translate }}
          </button>
        } @else if (webrtcCallState() === 'connected') {
          <button mat-flat-button color="warn" (click)="endVoiceChat()">
            <mat-icon>call_end</mat-icon>
            {{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.END_CALL' | translate }}
          </button>
        }
      }

      @if (showCTAButton()) {
        <button mat-stroked-button (click)="ctaClicked.emit()">
          {{ aiAssistant().cta.label | translate }}
        </button>
      }
      @if (isDisabled()) {
        <glxy-badge>{{ 'AI_ASSISTANT.SHARED.UPGRADE' | translate }}</glxy-badge>
      } @else if (isComingSoon() && !showConfigButton()) {
        <glxy-badge>{{ 'AI_ASSISTANT.SHARED.COMING_SOON' | translate }}</glxy-badge>
      }
      @if (showConfigButton()) {
        <button mat-stroked-button [routerLink]="[aiAssistantConfigUrl()]" (click)="onConfigureButtonClick()">
          {{ 'AI_ASSISTANT.WORKFORCE.CONFIGURE_BUTTON' | translate }}
        </button>
      }
    </div>
  </div>
</div>
